"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M97.9 414.6v31.2h-25c-3.5 0-6.3 2.8-6.3 6.3s2.8 6.2 6.3 6.2h62.5c3.5 0 6.2-2.8 6.2-6.2 0-3.5-2.8-6.3-6.2-6.3h-25v-31.2H97.9z"
  }), (0, _core.jsx)("path", {
    d: "M66.7 345.8v50c0 20.7 16.8 37.5 37.5 37.5s37.5-16.8 37.5-37.5v-50h-75z"
  }), (0, _core.jsx)("path", {
    d: "M154.2 358.3v18.8c0 10.4-8.4 18.8-18.8 18.8H72.9c-10.4 0-18.7-8.4-18.8-18.8v-18.8h100.1m0-12.5h-100c-6.9 0-12.5 5.6-12.5 12.5v18.8c0 17.3 14 31.2 31.2 31.2h62.5c17.3 0 31.2-14 31.2-31.2v-18.8c.1-6.9-5.5-12.5-12.4-12.5zM389.6 414.6v31.2h-25c-3.5 0-6.2 2.8-6.2 6.3s2.8 6.2 6.2 6.2h62.5c3.5 0 6.2-2.8 6.2-6.2 0-3.5-2.8-6.3-6.2-6.3h-25v-31.2h-12.5z"
  }), (0, _core.jsx)("path", {
    d: "M358.3 345.8v50c0 20.7 16.8 37.5 37.5 37.5s37.5-16.8 37.5-37.5v-50h-75z"
  }), (0, _core.jsx)("path", {
    d: "M445.8 358.3v18.8c0 10.4-8.4 18.8-18.7 18.8h-62.5c-10.4 0-18.8-8.4-18.8-18.8v-18.8h100m0-12.5h-100c-6.9 0-12.5 5.6-12.5 12.5v18.8c0 17.3 14 31.2 31.2 31.2H427c17.3 0 31.2-14 31.2-31.2v-18.8c.1-6.9-5.5-12.5-12.4-12.5zM243.8 110.4v31.2h-25c-3.5 0-6.2 2.8-6.2 6.3 0 3.4 2.8 6.2 6.2 6.2h62.5c3.5 0 6.2-2.8 6.2-6.3 0-3.4-2.8-6.2-6.2-6.2h-25v-31.2h-12.5z"
  }), (0, _core.jsx)("path", {
    d: "M212.5 41.7v50c0 20.7 16.8 37.5 37.5 37.5s37.5-16.8 37.5-37.5v-50h-75z"
  }), (0, _core.jsx)("path", {
    d: "M300 54.2V73c0 10.4-8.4 18.8-18.8 18.8h-62.5c-10.4 0-18.7-8.4-18.7-18.8V54.2h100m0-12.5H200c-6.9 0-12.5 5.6-12.5 12.5V73c0 17.3 14 31.2 31.2 31.2h62.5c17.3 0 31.2-14 31.2-31.2V54.2c.1-6.9-5.5-12.5-12.4-12.5zM250 187.5c5.8 0 10.4 4.7 10.4 10.4v62.5c0 5.8-4.7 10.4-10.4 10.4-5.8 0-10.4-4.7-10.4-10.4v-62.5c0-5.7 4.6-10.4 10.4-10.4z"
  }), (0, _core.jsx)("path", {
    d: "M256.4 261.1c2.9 5 1.2 11.4-3.8 14.2L190.7 311c-5 2.9-11.4 1.2-14.2-3.8-2.9-5-1.2-11.4 3.8-14.2l61.9-35.7c4.9-2.9 11.3-1.2 14.2 3.8z"
  }), (0, _core.jsx)("path", {
    d: "M243.6 261.2c2.9-5 9.2-6.7 14.2-3.8l61.9 35.7c5 2.9 6.7 9.2 3.8 14.2-2.9 5-9.2 6.7-14.2 3.8l-61.9-35.7c-5-2.8-6.7-9.2-3.8-14.2z"
  }));
};

exports.default = _default;